import { DP_ROLE } from './dp-usermanagement-constants'

export const FILTER_TYPES = {
  TICKET: 'ticket',
  ALL: 'all',
  OPENED: 'opened',
  CLOSED: 'closed',
  INFO: 'info',
  MESSAGING_ALL: 'messaging-all',
  MESSAGING_UNREAD: 'messaging-unread',
  NEWS_ALL: 'news-all',
  NEWS_READ: 'news-read',
  NEWS_UNREAD: 'news-unread',
  NEWS: 'news',
}

export const TAB_MAPPING = {
  ticket: 0,
  info: 1,
  news: 2,
}

export const CONSTANTS = {
  ANSWERFORM_ANCHOR: 'answerform',
  MESSAGE_TICKET_UPDATE_ENDPOINT: '/api/bucommonapi?code=message-update-ticket',
  MESSAGE_STATUS_INTERVAL: 5, // in minutes, 0 = off, > 0 = on
  MESSAGE_CENTER: 'MESSAGE_CENTER',
  ROUTES: {
    LIST: 'message-list',
  },
  MESSAGE_STATE_TYPES: {
    NEW: 1,
    OPEN: 2,
    CLOSED: 3,
    PENDING: 4,
    PENDIG_AUTO_CLOSE: 5,
    DELETED: 6,
    MERGED: 7, // disable answering
  },
  DISABLE_ANSWER_TICKET_ID: 9, // Disable Answering by Tickets. Type is 7 and ID is 9,
  FILTER_TYPES,
  FILTER_SORT: [
    {
      value: FILTER_TYPES.TICKET,
      perm: DP_ROLE.MESSAGING_TICKETS_R.p,
      content: [
        { value: FILTER_TYPES.ALL },
        { value: FILTER_TYPES.OPENED },
        { value: FILTER_TYPES.CLOSED },
      ],
      defaultFilter: FILTER_TYPES.OPENED,
    },
    {
      value: FILTER_TYPES.INFO,
      perm: DP_ROLE.MESSAGING_INFORMATIONS_R.p,
      content: [{ value: FILTER_TYPES.MESSAGING_UNREAD }, { value: FILTER_TYPES.MESSAGING_ALL }],
      defaultFilter: FILTER_TYPES.MESSAGING_ALL,
    },
    {
      value: FILTER_TYPES.NEWS,
      perm: DP_ROLE.MESSAGING_NEWS_R.p,
      content: [
        { value: FILTER_TYPES.NEWS_ALL },
        { value: FILTER_TYPES.NEWS_READ },
        { value: FILTER_TYPES.NEWS_UNREAD },
      ],
      defaultFilter: FILTER_TYPES.NEWS_UNREAD,
    },
  ],
  BU_WIDGETS_FILTER_SORT: [
    {
      value: FILTER_TYPES.TICKET,
      perm: DP_ROLE.MESSAGING_TICKETS_R.p,
      content: [
        { value: FILTER_TYPES.ALL },
        { value: FILTER_TYPES.OPENED },
        { value: FILTER_TYPES.CLOSED },
      ],
      defaultFilter: FILTER_TYPES.OPENED,
    },
    {
      value: FILTER_TYPES.INFO,
      perm: DP_ROLE.MESSAGING_INFORMATIONS_R.p,
      content: [{ value: FILTER_TYPES.MESSAGING_UNREAD }, { value: FILTER_TYPES.MESSAGING_ALL }],
      defaultFilter: FILTER_TYPES.MESSAGING_UNREAD,
    },
    {
      value: FILTER_TYPES.NEWS,
      perm: DP_ROLE.MESSAGING_NEWS_R.p,
      content: [
        { value: FILTER_TYPES.NEWS_ALL },
        { value: FILTER_TYPES.NEWS_READ },
        { value: FILTER_TYPES.NEWS_UNREAD },
      ],
      defaultFilter: FILTER_TYPES.NEWS_UNREAD,
    },
  ],
  TICKET_HEADER_FALLBACK: 'Hubspot',
}
